import router, { permissionRouter } from './router'
import store from './store'
import { Message } from 'element-ui'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { findIndex,some } from 'lodash'
import changRouter from "@/utils/changeRouter.js"
import axios from '../src/utils/request.js';
import apiurl from '@/interface/apiurls.js';

NProgress.configure({ showSpinner: false })
// 白名单
const whiteList = ['/login', '/404','/401','/','/Main','/details','/details_shed','/EditOffice','/edit-doc','/see-doc','/content-biaoge']

router.beforeEach((to, from, next) => {
  if(from){
    sessionStorage.setItem('previousPath',from.path)
  }
  NProgress.start()
  if (sessionStorage.getItem('token')) {
    const permissions = store.getters.permissions;
    if(!feterdate(router.options.routes,to.path)){ return  next({ path: '/404' }) };
    // 判断路由是否存在
    if(findIndex(permissionRouter,{ path:to.path })==-1){
      next()
    }else{
       // 判断是否有访问权限，没有权限则跳转401
      if(findIndex(permissions,{ path:to.path }) ==-1){
        next({ path: '/401' })
      }else{
        next()
      }
    }
    
   
    NProgress.done()
  } else {
    next() // 否则全部重定向到登录页
    NProgress.done()
  }
})

router.afterEach(() => {
  NProgress.done()
})
function feterdate(routes,path){
  // 使用lodash的_.some()来检查  
  const containsPath = some(routes, route => {  
    // 如果当前route有children，则递归检查children  
    if (route.children) {  
      return _.some(route.children, child => child.path === path);  
    }  
    // 否则直接检查当前route的path  
    return route.path === path;  
  });
  console.log('当前路由',path,containsPath)
  return containsPath;
}


